module.exports = __webpack_public_path__ + "static/media/icon_button1_a.99044810.svg";